import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/services/page.tsx");
